import { some } from 'lodash'
import React from 'react'
import { Header } from 'semantic-ui-react'
import { ReadOnlyFieldDisplay } from '../../components/ReadOnlyFieldDisplay'
import { numberToDollars } from '../../utils'
import { SpecialInstructionDisplay } from './constants'
import styles from './styles.module.less'
import { LotMatchingInstruction, SpecialInstruction, TradeFormValues } from './Types'

const TradeInstructionsPreview = ({
  values: { specialInstructions, lotMatchingInstructions },
}: {
  values: TradeFormValues
}) => {
  return (
    <div className={`trade-instructions-preview ${styles.tradeInstructionsPreview}`}>
      {some(specialInstructions, ({ value }: SpecialInstruction) => value) && (
        <div className={`special-instructions ${styles.specialInstructions}`}>
          <Header as="h3">Special Instructions</Header>
          {specialInstructions?.map(
            ({ id, value }: SpecialInstruction) =>
              value && (
                <ReadOnlyFieldDisplay
                  className="special-instruction-preview"
                  key={id}
                  label="Special Instruction"
                  value={SpecialInstructionDisplay[value]}
                />
              )
          )}
        </div>
      )}
      {some(
        lotMatchingInstructions,
        ({ tradeDate, quantity, price }: LotMatchingInstruction) => tradeDate || quantity || price
      ) && (
        <div className={`lot-matching-instructions ${styles.lotMatchingInstructions}`}>
          <Header as="h3">Lot Matching Instructions</Header>
          {lotMatchingInstructions?.map(
            ({ id, tradeDate, quantity, price }: LotMatchingInstruction) =>
              tradeDate && (
                <div className={styles.lotMatchingInstruction} key={id}>
                  <ReadOnlyFieldDisplay className="trade-date-preview" label="Trade Date" value={tradeDate} />
                  <ReadOnlyFieldDisplay
                    className="quantity-preview"
                    label="Quantity"
                    value={quantity ? `${quantity}` : undefined}
                  />
                  <ReadOnlyFieldDisplay
                    className="price-preview"
                    label="Price"
                    value={price ? numberToDollars(price) : undefined}
                  />
                </div>
              )
          )}
        </div>
      )}
    </div>
  )
}

export default TradeInstructionsPreview
